import { useAsyncData } from '#imports'
import { computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { removeEmptyValuesInObject } from '@backmarket/utils/object/removeEmptyValuesInObject'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchServicePickers() {
  const { productId, mobilePlan } = useUrlParams()
  const $httpFetch = useHttpFetch()

  const servicePickersQueryParams = computed(() => {
    return removeEmptyValuesInObject({
      mobile_plan_offer_id: mobilePlan.value ? String(mobilePlan.value) : null,
    })
  })

  return useAsyncData(
    `pp-services-pickers-${productId}-${mobilePlan.value}`,
    async () =>
      $httpFetch('/product-page/products/:productId/services/pickers', {
        pathParams: { productId },
        query: servicePickersQueryParams.value,
      }),
    {
      // Services pickers currently returns mobile plan & trade-in pickers. They're only called
      // client-side as they rely on user's session (especially the trade-in one, that checks the user's cart),
      // meaning that we can't cache their response.
      server: false,
      // Use immediate:false and watch:false to activate the kill switch on this endpoint.
      lazy: true,
      dedupe: 'defer',
    },
  )
}
